<template>
	<div class="w-full">
		<h2 class="border-b text-2xl font-light md:text-4xl">Personal Information</h2>

		<div class="flex justify-between -mx-2 flex-col sm:flex-row">
			<div class="mx-2 flex flex-col flex-1 mt-4">
				<label for="first" class="uppercase text-xs pl-2 font-semibold">First Name*</label>
				<input type="text" autocomplete="given-name" v-model="$v.first.$model" :class="$v.first.$invalid && $v.$dirty ? 'border-red' : ''" name="first" class="shadow-inner border rounded px-2 h-8 w-full">
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="$v.first.$invalid && $v.$dirty">Required</p>
			</div>
			<div class="mx-2 flex flex-col flex-1 mt-4">
				<label for="middle" class="uppercase text-xs pl-2 font-semibold">Middle Name</label>
				<input type="text" autocomplete="additional-name" v-model="$v.middle.$model" :class="$v.middle.$invalid && $v.$dirty ? 'border-red' : ''" name="middle" class="shadow-inner border rounded px-2 h-8 w-full">
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="$v.middle.$invalid && $v.$dirty"></p>
			</div>
			<div class="mx-2 flex flex-col flex-1 mt-4">
				<label for="last" class="uppercase text-xs pl-2 font-semibold">Last Name*</label>
				<input type="text" autocomplete="family-name" v-model="$v.last.$model" :class="$v.last.$invalid && $v.$dirty ? 'border-red' : ''" name="last" class="shadow-inner border rounded px-2 h-8 w-full">
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="$v.last.$invalid && $v.$dirty">Required</p>
			</div>
		</div>

		<div class="flex justify-between -mx-2">
			<div class="mx-2 flex flex-col flex-1 mt-4">
				<label for="address1" class="uppercase text-xs pl-2 font-semibold">Address 1*</label>
				<input type="text" autocomplete="street-address" v-model="$v.address1.$model" :class="$v.address1.$invalid && $v.$dirty ? 'border-red' : ''" name="address1" class="shadow-inner border rounded px-2 h-8 w-full">
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="$v.address1.$invalid && $v.$dirty">Required</p>
			</div>
		</div>

		<div class="flex justify-between -mx-2 flex-col sm:flex-row">
			<div class="mx-2 flex flex-col flex-1 mt-4">
				<label for="address2" class="uppercase text-xs pl-2 font-semibold">Address 2</label>
				<input type="text" autocomplete="address-line2" v-model="$v.address2.$model" :class="$v.address2.$invalid && $v.$dirty ? 'border-red' : ''" name="address2" class="shadow-inner border rounded px-2 h-8 w-full">
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="$v.address2.$invalid && $v.$dirty"></p>
			</div>
		</div>

		<div class="flex justify-between -mx-2 flex-col sm:flex-row">
			<div class="mx-2 flex flex-col flex-1 mt-4">
				<label for="city" class="uppercase text-xs pl-2 font-semibold">City*</label>
				<input type="text" autocomplete="address-level2" v-model="$v.city.$model" :class="$v.city.$invalid && $v.$dirty ? 'border-red' : ''" name="city" class="shadow-inner border rounded px-2 h-8 w-full">
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="$v.city.$invalid && $v.$dirty">Required</p>
			</div>
			<div class="mx-2 flex flex-col flex-1 mt-4">
				<label for="state" class="uppercase text-xs pl-2 font-semibold">State*</label>
				<select v-model="$v.state.$model" autocomplete="address-level1" :class="$v.state.$invalid && $v.$dirty ? 'border-red' : ''" name="state" class="bg-white shadow-inner border rounded px-2 h-8 w-full">
					<option value=""></option>
					<option value="AL">Alabama</option>
					<option value="AK">Alaska</option>
					<option value="AZ">Arizona</option>
					<option value="AR">Arkansas</option>
					<option value="CA">California</option>
					<option value="CO">Colorado</option>
					<option value="CT">Connecticut</option>
					<option value="DE">Delaware</option>
					<option value="DC">District Of Columbia</option>
					<option value="FL">Florida</option>
					<option value="GA">Georgia</option>
					<option value="HI">Hawaii</option>
					<option value="ID">Idaho</option>
					<option value="IL">Illinois</option>
					<option value="IN">Indiana</option>
					<option value="IA">Iowa</option>
					<option value="KS">Kansas</option>
					<option value="KY">Kentucky</option>
					<option value="LA">Louisiana</option>
					<option value="ME">Maine</option>
					<option value="MD">Maryland</option>
					<option value="MA">Massachusetts</option>
					<option value="MI">Michigan</option>
					<option value="MN">Minnesota</option>
					<option value="MS">Mississippi</option>
					<option value="MO">Missouri</option>
					<option value="MT">Montana</option>
					<option value="NE">Nebraska</option>
					<option value="NV">Nevada</option>
					<option value="NH">New Hampshire</option>
					<option value="NJ">New Jersey</option>
					<option value="NM">New Mexico</option>
					<option value="NY">New York</option>
					<option value="NC">North Carolina</option>
					<option value="ND">North Dakota</option>
					<option value="OH">Ohio</option>
					<option value="OK">Oklahoma</option>
					<option value="OR">Oregon</option>
					<option value="PA">Pennsylvania</option>
					<option value="RI">Rhode Island</option>
					<option value="SC">South Carolina</option>
					<option value="SD">South Dakota</option>
					<option value="TN">Tennessee</option>
					<option value="TX">Texas</option>
					<option value="UT">Utah</option>
					<option value="VT">Vermont</option>
					<option value="VA">Virginia</option>
					<option value="WA">Washington</option>
					<option value="WV">West Virginia</option>
					<option value="WI">Wisconsin</option>
					<option value="WY">Wyoming</option>
				</select>
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="$v.state.$invalid && $v.$dirty">Required</p>
			</div>
			<div class="mx-2 flex flex-col flex-1 mt-4">
				<label for="zip" class="uppercase text-xs pl-2 font-semibold">Zip*</label>
				<input type="number" v-model="$v.zip.$model" autocomplete="postal-code" :class="$v.zip.$invalid && $v.$dirty ? 'border-red' : ''" name="zip" class="shadow-inner border rounded px-2 h-8 w-full">
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="$v.zip.$invalid && $v.$dirty">Required</p>
			</div>
		</div>

		<div class="flex justify-between -mx-2 flex-col sm:flex-row">
			<div class="mx-2 flex flex-col flex-1 mt-4">
				<label for="email" class="uppercase text-xs pl-2 font-semibold">Email Address*</label>
				<input type="email" autocomplete="email" v-model="$v.email.$model" :class="$v.email.$invalid && $v.$dirty ? 'border-red' : ''" name="email" class="shadow-inner border rounded px-2 h-8 w-full">
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="!$v.email.required && $v.$dirty">Required</p>
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="!$v.email.email && $v.$dirty">Must be valid</p>
			</div>
			<div class="mx-2 flex flex-col mt-4 md:w-1/3">
				<label for="phone" class="uppercase text-xs pl-2 font-semibold">Phone Number*</label>
				<input type="tel" autocomplete="tel" v-model="$v.phone.$model" :class="$v.phone.$invalid && $v.$dirty ? 'border-red' : ''" name="phone" class="shadow-inner border rounded px-2 h-8 w-full">
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="!$v.phone.required && $v.$dirty">Required</p>
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="!$v.phone.validPhone && $v.$dirty">Must be valid</p>
			</div>
		</div>

		<div class="mt-8 flex text-lg justify-between">
			<button @click="submit" :class="{ 'opacity-50 cursor-not-allowed' : $v.$invalid && $v.$dirty }" class="ml-auto font-semibold bg-green-dark text-white py-2 px-4 rounded ml-4 block">Continue</button>
		</div>
	</div>
</template>

<script>
	import { email, required } from 'vuelidate/lib/validators'
	import { parsePhoneNumberFromString } from 'libphonenumber-js'

	const validPhone = function (n) {
		if (n === '') {
			return true
		}

		const phoneNumber = parsePhoneNumberFromString(n, 'US')
		return phoneNumber ? phoneNumber.isValid() : false
	}

	export default {
		created() {
			this.first = this.$store.state.form.personal.first
			this.middle = this.$store.state.form.personal.middle
			this.last = this.$store.state.form.personal.last
			this.address1 = this.$store.state.form.personal.address1
			this.address2 = this.$store.state.form.personal.address2
			this.city = this.$store.state.form.personal.city
			this.state = this.$store.state.form.personal.state
			this.zip = this.$store.state.form.personal.zip
			this.email = this.$store.state.form.personal.email
			this.phone = this.$store.state.form.personal.phone
		},

		data() {
			return {
				submitting: false,

				first: '',
				middle: '',
				last: '',
				address1: '',
				address2: '',
				city: '',
				state: '',
				zip: '',
				email: '',
				phone: '',
			}
		},

		validations: {
			first: { required },
			middle: {},
			last: { required },
			address1: { required },
			address2: {},
			city: { required },
			state: { required },
			zip: { required },
			email: { email, required },
			phone: { validPhone, required },
		},

		methods: {
			submit() {
				if (this.$v.$invalid || this.submitting) {
					this.$v.$touch()
					return
				}

				this.submitting = true

				this.$store.commit('setPersonal', {
					first: this.first,
					middle: this.middle,
					last: this.last,
					address1: this.address1,
					address2: this.address2,
					city: this.city,
					state: this.state,
					zip: this.zip,
					email: this.email,
					phone: this.phone,
				})

				this.$router.push('/questionnaire')
			}
		},
	}
</script>
